import { useEffect, useState } from "react";

/**
 * Shows a celebratory banner at the top of the screen for ~3.5 seconds
 * when a profile says its very first word. Self-dismisses; appears once
 * per profile lifetime (state lives on backend, not local).
 */
export default function FirstWordToast({ open, onDone, message }) {
  const [phase, setPhase] = useState("enter"); // enter | hold | leave

  useEffect(() => {
    if (!open) return;
    setPhase("enter");
    const t1 = setTimeout(() => setPhase("hold"), 50);
    const t2 = setTimeout(() => setPhase("leave"), 3000);
    const t3 = setTimeout(() => onDone?.(), 3500);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, [open, onDone]);

  if (!open) return null;

  const translateY =
    phase === "enter" ? "-120%" : phase === "leave" ? "-120%" : "0";

  return (
    <div
      data-testid="first-word-toast"
      style={{
        position: "fixed",
        top: 16,
        left: "50%",
        transform: `translate(-50%, 0) translateY(${translateY})`,
        transition: "transform 380ms cubic-bezier(.2,.9,.3,1.4)",
        zIndex: 200,
        pointerEvents: "none",
        maxWidth: "min(92vw, 560px)",
      }}
    >
      <div
        className="brutal-card"
        style={{
          background: "var(--gold)",
          padding: "14px 22px",
          display: "flex",
          alignItems: "center",
          gap: 12,
          borderRadius: 999,
        }}
      >
        <span style={{ fontSize: 28 }} aria-hidden>🎉</span>
        <span className="display" style={{ fontWeight: 800, fontSize: 18, lineHeight: 1.15 }}>
          {message}
        </span>
        <span style={{ fontSize: 28 }} aria-hidden>🎉</span>
      </div>
    </div>
  );
}
